module.exports = __webpack_public_path__ + "img/closeButtonBlue@3x.ed3447dd.png";